module.exports = __webpack_public_path__ + "static/media/tasks.ea9db153.svg";